import script from "./LRoutingMachine.vue?vue&type=script&lang=js"
export * from "./LRoutingMachine.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__